import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';

const groups = [
  {
    label: 'Account',
    links: [
      { to: '/dashboard', label: 'Overview', end: true },
      { to: '/dashboard/api-keys', label: 'API Keys' },
      { to: '/dashboard/endpoints', label: 'RPC Endpoints' },
      { to: '/dashboard/usage', label: 'Usage Logs' },
      { to: '/dashboard/wallet', label: 'Wallet' },
      { to: '/dashboard/billing', label: 'Billing & Plans' },
      { to: '/dashboard/profile', label: 'Profile' },
    ],
  },
];

export default function DashboardLayout() {
  return (
    <div className="app-shell">
      <Sidebar groups={groups} />
      <main className="app-content">
        <Outlet />
      </main>
    </div>
  );
}
